import {
  useEffect,
  useMemo,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Upload as AtUpload, message, Button } from "antd";
// import OSS from "ali-oss";
import { UploadOutlined } from "@ant-design/icons";
import { getToken } from "../../../../utils/token";
// import commonApi from "../../../../apis/commonApi";

const Upload = forwardRef(({ isView, defaultFileList }, ref) => {
  const [fileList, setFileList] = useState([]);
  const [jwt, setJwt] = useState();

  useImperativeHandle(ref, () => ({
    fileList,
  }));

  useEffect(() => {
    if (isView) return;
    getToken()
      .then((res) => {
        const { success, data } = res;
        if (success && data) {
          setJwt(data.jwt);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [isView]);

  useEffect(() => {
    if (defaultFileList) {
      setFileList(defaultFileList);
    }
  }, [defaultFileList]);

  // 图片文件：.jpg, .jpeg, .png, .gif, .bmp
  // Excel 文件：.xls, .xlsx, .xlsm
  // PDF 文件：.pdf
  // Word 文件：.doc, .docx, .rtf, .odt
  const uploadProps = useMemo(
    () => ({
      name: "file",
      accept:
        ".jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx,.xlsm,.pdf,.doc,.docx,.rtf,.odt",
      maxCount: 5,
      multiple: true,
      action: "/crm-venus/v1/venus/files/fileUpload/default",
      headers: {
        jwt,
      },
      beforeUpload: (file) => {
        // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        // if (!isJpgOrPng) {
        //   message.error('You can only upload JPG/PNG file!');
        // }
        const isLtSize = file.size / 1024 / 1024 < 10;
        if (!isLtSize) {
          message.error("单个文件大小不得超过10MB!");
        }
        return isLtSize;
      },
      onChange(info) {
        // console.log(info.file, info.fileList);
        if (info.file.status) {
          const _newFileList = info.fileList.filter((item) => item.status);
          setFileList(_newFileList);
        }
        if (info.file.status !== "uploading") {
        }
        if (info.file.status === "done") {
          // console.log(info.file.name);
          if (info.file.response && info.file.response.data) {
            message.success(`${info.file.name} 附件上传成功`);
          } else {
            const errInfo =
              info.file.response?.errorMsg || `${info.file.name} 附件上传失败`;
            message.error(errInfo);
            info.file.status = "error";
            info.file.response = errInfo;
          }
        } else if (info.file.status === "error") {
          message.error(`${info.file.name} 附件上传失败`);
        }
      },
      // customRequest: async (file) => {
      //   console.log("uploadFile方法");
      //   console.log(file);

      //   try {
      //     // const result = await commonApi.fileUploadVenus
      //     // const result = await commonApi.getOssKey();
      //     // const client = new OSS({
      //     //   region: "oss-cn-shanghai", // 例如 oss-cn-hangzhou
      //     //   accessKeyId: "",
      //     //   accessKeySecret: "",
      //     //   stsToken: result.securityToken,
      //     //   bucket: "yd-crm-test-oss",
      //     //   ...result,
      //     // });
      //     // console.log(file, result);
      //     // const filename = "example/" + file.file.name;

      //     // // let { res } = await client.multipartUpload(filename, file, {
      //     // //   headers: {
      //     // //     'x-oss-object-acl': 'public-read', // 设置文件为公共读权限
      //     // //   },
      //     // //   meta: {
      //     // //     'Content-Type': file.type
      //     // //   }
      //     // // })
      //     // const { res } = await client.put(filename, file.file, {
      //     //   headers: {
      //     //     "x-oss-object-acl": "public-read", // 设置文件为公共读权限
      //     //   },
      //     //   meta: {
      //     //     "Content-Type": file.file.type,
      //     //   },
      //     // });
      //     // console.log(res);
      //     // const urls = (res?.requestUrls || []).map((url) => ({ url }));
      //     // console.log(111, urls);
      //     // file.onSuccess(urls, file);
      //   } catch (error) {
      //     console.log("error====", error);
      //     file.onError(error);
      //   }

      //   // uploadApi({
      //   //   file: file.file,
      //   //   onUploadProgress: (ev) => {
      //   //     // ev - axios 上传进度实例，上传过程触发多次
      //   //     // ev.loaded 当前已上传内容的大小，ev.total - 本次上传请求内容总大小
      //   //     console.log(ev);
      //   //     const percent = (ev.loaded / ev.total) * 100;
      //   //     // 计算出上传进度，调用组件进度条方法
      //   //     file.onProgress({ percent });
      //   //   },
      //   // })
      //   //   .then((res) => {
      //   //     console.log("上传成功" + res);
      //   //     file.onSuccess(res, file);
      //   //   })
      //   //   .catch((err) => {
      //   //     file.onError(err);
      //   //   });
      // },
    }),
    [jwt]
  );

  return (
    <AtUpload
      fileList={fileList}
      disabled={isView}
      className={`upload-wrapper ${isView ? "disabled" : ""}`}
      {...uploadProps}
    >
      <Button icon={<UploadOutlined />}>上传附件</Button>
    </AtUpload>
  );
});

export default Upload;
